<template>
  <div class="content relative">
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col>
          <h2 class="mb-0">Zonesoft – Sincronização</h2>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <!-- FORM CARD -->
      <card class="no-border-card mb-4" body-classes="p-4">
        <b-row>
          <b-col md="4">
            <base-input label="Restaurante de origem">
              <el-select
                v-model="source"
                placeholder="Selecionar origem"
                class="w-100"
              >
                <el-option
                  v-for="r in restaurantes"
                  :key="r.value"
                  :label="r.label"
                  :value="r.value"
                />
              </el-select>
            </base-input>
          </b-col>

          <b-col md="4">
            <base-input label="Atualizar">
              <el-select v-model="targetMode" class="w-100">
                <el-option label="Todos os restaurantes" value="todos" />
                <el-option label="Um restaurante" value="um" />
                <el-option label="Vários restaurantes" value="varios" />
              </el-select>
            </base-input>
          </b-col>

          <b-col md="4" v-if="targetMode === 'um'">
            <base-input label="Restaurante alvo">
              <el-select
                v-model="targets"
                class="w-100"
                placeholder="Selecionar Restaurantes"
              >
                <el-option
                  v-for="r in restaurantesFiltrados"
                  :key="r.value"
                  :label="r.label"
                  :value="r.value"
                />
              </el-select>
            </base-input>
          </b-col>

          <b-col md="4" v-if="targetMode === 'varios'">
            <base-input label="Restaurantes alvo">
              <el-select
                v-model="targets"
                multiple
                collapse-tags
                class="w-100"
                placeholder="Selecionar Restaurantes"
              >
                <el-option
                  v-for="r in restaurantesFiltrados"
                  :key="r.value"
                  :label="r.label"
                  :value="r.value"
                />
              </el-select>
            </base-input>
          </b-col>
        </b-row>

        <b-row class="pt-3">
          <b-col md="3">
            <base-button
              type="primary"
              block
              :disabled="loading || !source"
              @click="sync"
            >
              {{ loading ? "A iniciar..." : "Iniciar sincronização" }}
            </base-button>
          </b-col>
        </b-row>
      </card>

      <!-- JOBS -->
      <card
        v-if="jobs.length"
        class="no-border-card table-card"
        body-classes="px-0 pb-1"
      >
        <el-table
          :data="jobs"
          header-row-class-name="thead-light"
          style="width: 100%"
        >
          <el-table-column
            label="#"
            width="80"
            prop="id"
            :formatter="(r) => `#${r.id}`"
          />

          <el-table-column label="Origem" prop="source" />

          <el-table-column
            label="Progresso"
            width="140"
            :formatter="(r) => `${progresso(r)}%`"
          />

          <el-table-column label="Criados" prop="criados" width="120" />
          <el-table-column label="Atualizados" prop="atualizados" width="140" />
          <el-table-column label="Erros" prop="erros" width="100" />
          <el-table-column
            label="Estado"
            prop="status"
            :formatter="formatarEstado"
          />
          <el-table-column label="" width="250" align="right">
            <template slot-scope="{ row }">
              <base-button
                size="sm"
                type="primary"
                class="btn-link"
                @click="abrirDetalhesJob(row)"
              >
                Ver detalhes
              </base-button>
            </template>
          </el-table-column>
        </el-table>
      </card>

      <!-- ERRO -->
      <b-alert v-if="error" variant="danger" class="mt-3" show>
        <strong>Erro:</strong> {{ error }}
      </b-alert>
    </b-container>
    <b-modal
      v-model="modalJob"
      size="lg"
      title="Detalhes da sincronização"
      hide-footer
    >
      <div v-if="loadingJob" class="text-center py-4">
        A carregar detalhes...
      </div>

      <div v-else-if="jobSelecionado">
        <!-- LINHA 1 -->
        <b-row class="mb-3">
          <b-col md="4">
            <div class="stat-box">
              <div class="stat-label">Origem</div>
              <div class="stat-value">{{ jobSelecionado.source }}</div>
            </div>
          </b-col>

          <b-col md="4">
            <div class="stat-box">
              <div class="stat-label">Estado</div>
              <div
                class="stat-value"
                :class="`status-${jobSelecionado.status}`"
              >
                {{
                  jobSelecionado.status == "done"
                    ? "Concluído"
                    : jobSelecionado.status == "running"
                    ? "A processar"
                    : jobSelecionado.status == "pending"
                    ? "Pendente"
                    : jobSelecionado.status == "failed"
                    ? "Falhou a sincronização"
                    : jobSelecionado.status
                }}
              </div>
            </div>
          </b-col>

          <b-col md="4">
            <div class="stat-box">
              <div class="stat-label">Progresso</div>
              <div class="stat-value">{{ progresso(jobSelecionado) }}%</div>
            </div>
          </b-col>
        </b-row>

        <!-- LINHA 2 -->
        <b-row class="mb-3">
          <b-col md="3">
            <div class="stat-box">
              <div class="stat-label">Total</div>
              <div class="stat-value">{{ jobSelecionado.total }}</div>
            </div>
          </b-col>

          <b-col md="3">
            <div class="stat-box">
              <div class="stat-label">Criados</div>
              <div class="stat-value text-success">
                {{ jobSelecionado.criados }}
              </div>
            </div>
          </b-col>

          <b-col md="3">
            <div class="stat-box">
              <div class="stat-label">Atualizados</div>
              <div class="stat-value text-primary">
                {{ jobSelecionado.atualizados }}
              </div>
            </div>
          </b-col>

          <b-col md="3">
            <div class="stat-box">
              <div class="stat-label">Erros</div>
              <div class="stat-value text-danger">
                {{ jobSelecionado.erros }}
              </div>
            </div>
          </b-col>
        </b-row>

        <!-- LINHA 3 -->
        <b-row>
          <b-col md="6">
            <div class="stat-box">
              <div class="stat-label">Início</div>
              <div class="stat-value">
                {{ formatarData(jobSelecionado.created_at) }}
              </div>
            </div>
          </b-col>

          <b-col md="6">
            <div class="stat-box">
              <div class="stat-label">Fim</div>
              <div class="stat-value">
                {{
                  jobSelecionado.finished_at
                    ? formatarData(jobSelecionado.finished_at)
                    : "—"
                }}
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { cartaoService, dashboardService } from "@/services";

export default {
  name: "ZonesoftSyncTest",

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      loading: false,
      error: null,

      restaurantes: [],
      source: "",
      targetMode: "todos",
      targets: [],

      jobs: [],
      polling: null, // 🔒 continua sem polling
      modalJob: false,
      loadingJob: false,
      jobSelecionado: null,
      jobLogs: [],
    };
  },

  computed: {
    restaurantesFiltrados() {
      return this.restaurantes.filter((r) => r.value !== this.source);
    },
  },

  mounted() {
    this.carregarRestaurantes();
    this.carregarJobs();

    // this.polling = setInterval(this.carregarJobs, 4000);
  },

  methods: {
    formatarEstado(row) {
      switch (row.status) {
        case "done":
          return "Concluído";
        case "running":
          return "A processar";
        case "pending":
          return "Pendente";
        case "failed":
          return "Falhou a sincronização";
        default:
          return row.status;
      }
    },
    async abrirDetalhesJob(job) {
      this.modalJob = true;
      this.loadingJob = true;
      this.jobSelecionado = null;
      this.jobLogs = [];

      try {
        const data = await cartaoService.getSyncJobDetails(job.id);
        this.jobSelecionado = data.job;
        this.jobLogs = data.logs;
      } catch (err) {
        this.$notify({
          message: "<b>Erro ao carregar detalhes do job.</b>",
          timeout: 2500,
          icon: "ni ni-bell-55",
          type: "danger",
        });
        this.modalJob = false;
      } finally {
        this.loadingJob = false;
      }
    },
    progresso(job) {
      if (!job.total) return 0;
      return Math.round((job.processed / job.total) * 100);
    },
    formatarData(data) {
      if (!data) return "—";
      const d = new Date(data);
      return d.toLocaleString("pt-PT", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    async carregarRestaurantes() {
      const rests = await dashboardService.getRestaurantes();
      this.restaurantes = rests.map((r) => ({
        value: r.nome,
        label: r.nome,
      }));
    },

    async carregarJobs() {
      this.jobs = await cartaoService.getSyncJobs();
    },

    async sync() {
      this.loading = false;

      // -----------------------------
      // 1️⃣ Validações
      // -----------------------------
      if (!this.source) {
        this.$notify({
          type: "warning",
          title: "Campo obrigatório",
          message: "Selecione o restaurante de origem.",
        });
        return;
      }

      if (this.targetMode === "um" && !this.targets) {
        this.$notify({
          type: "warning",
          title: "Campo obrigatório",
          message: "Selecione o restaurante alvo.",
        });
        return;
      }

      if (
        this.targetMode === "varios" &&
        (!Array.isArray(this.targets) || this.targets.length === 0)
      ) {
        this.$notify({
          type: "warning",
          title: "Campo obrigatório",
          message: "Selecione pelo menos um restaurante alvo.",
        });
        return;
      }

      // -----------------------------
      // 2️⃣ Envio
      // -----------------------------
      this.loading = true;

      try {
        const payload = {
          source: this.source,
          targets:
            this.targetMode === "todos"
              ? "todos"
              : this.targetMode === "um"
              ? [this.targets]
              : this.targets,
        };

        await cartaoService.iniciarSync(payload);

        // -----------------------------
        // ✅ Sucesso
        // -----------------------------
        this.$notify({
          type: "success",
          title: "Sincronização iniciada",
          message:
            "A sincronização foi iniciada. Pode acompanhar o progresso na lista abaixo.",
        });

        await this.carregarJobs();
      } catch (err) {
        // -----------------------------
        // ❌ Erro
        // -----------------------------
        this.$notify({
          type: "danger",
          title: "Erro ao iniciar sincronização",
          message:
            err.response?.data?.erro ||
            "Ocorreu um erro ao iniciar a sincronização. Tente novamente mais tarde.",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.no-border-card {
  border: 0;
}

.table-card {
  position: relative;
}

.thead-light th {
  background: #f6f9fc;
}
.stat-box {
  background: #f8f9fe;
  border-radius: 8px;
  padding: 14px;
  height: 100%;
}

.stat-label {
  font-size: 11px;
  text-transform: uppercase;
  color: #8898aa;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 18px;
  font-weight: 600;
  color: #32325d;
}

/* estados (opcional) */
.status-running {
  color: #fb6340;
}

.status-finished {
  color: #2dce89;
}

.status-error {
  color: #f5365c;
}
.modal-content header {
  padding: 1.5rem !important;
}
</style>
